"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateSimulatedPersonRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class UpdateSimulatedPersonRequestDto {}
exports.UpdateSimulatedPersonRequestDto = UpdateSimulatedPersonRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  example: 'Alex'
}), __metadata("design:type", String)], UpdateSimulatedPersonRequestDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  example: 'Rivera'
}), __metadata("design:type", String)], UpdateSimulatedPersonRequestDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  example: 'https://picsum.photos/seed/demo1/600/800'
}), __metadata("design:type", Object)], UpdateSimulatedPersonRequestDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.Gender,
  required: false
}), __metadata("design:type", String)], UpdateSimulatedPersonRequestDto.prototype, "gender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SubGender,
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UpdateSimulatedPersonRequestDto.prototype, "subGender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [String],
  enum: enums_1.Gender,
  required: false
}), __metadata("design:type", Array)], UpdateSimulatedPersonRequestDto.prototype, "preferredGenders", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UpdateSimulatedPersonRequestDto.prototype, "showGenderPreferences", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  example: '06-15-1995',
  description: 'Date of birth in MM-DD-YYYY.'
}), __metadata("design:type", String)], UpdateSimulatedPersonRequestDto.prototype, "dateOfBirth", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UpdateSimulatedPersonRequestDto.prototype, "vibeEmoji", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Intention dictionary public id. Pass null to clear.'
}), __metadata("design:type", Object)], UpdateSimulatedPersonRequestDto.prototype, "intentionPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UpdateSimulatedPersonRequestDto.prototype, "isPhotoVerified", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UpdateSimulatedPersonRequestDto.prototype, "isActive", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UpdateSimulatedPersonRequestDto.prototype, "notes", void 0);
//# sourceMappingURL=UpdateSimulatedPersonRequest.dto.js.map